module.exports = __webpack_public_path__ + "static/media/consumer.3b274be6.svg";